import { FC } from "react";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import "./Footer.scss";

export const Footer: FC = (props: any) => {
  const gaEventTracker = useAnalyticsEventTracker('Footer');

  return (
    <footer>
      <div>
        <div>© Copyright {new Date().getFullYear()}.</div>
        <div>
          All rights reserved. Powered by the{" "}
          <a target={"_blank"} onClick={ ()=> gaEventTracker('nurdsoft site')} href="https://www.nurdsoft.co">
            nurdsoft.co
          </a>
          .
        </div>
      </div>
    </footer>
  );
};

export default Footer;
